import React, { useEffect, useState } from "react";
import { Paper, Grid, TextField, Button, Box, MenuItem } from "@mui/material";
import { useSnackbar } from "notistack";
import AuthService from "../../../AuthService";

const TIMEZONES = [
  { value: "-05:00", label: "Acre (ACT) -05:00" },
  { value: "-04:00", label: "Amazonas (AMT) -04:00" },
  { value: "-03:00", label: "Brasília (BRT) -03:00 (timezone padrão)" },
  { value: "-02:00", label: "Fernando de Noronha (FNT) -02:00" },
];

export default function ConfigurarTimezone() {
  const { enqueueSnackbar } = useSnackbar();
  const [empresa, setEmpresa] = useState(null);
  const [timezone, setTimezone] = useState("");
  const service = new AuthService();

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const empresa = await service.get("/login/empresaLogada");
        setEmpresa(empresa);
        setTimezone(empresa.timezone || "");
      } catch (error) {
        console.error("Erro ao buscar empresa:", error);
      }
    };

    fetchEmpresa();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTimezoneChange = (event) => {
    setTimezone(event.target.value);
  };

  const handleSalvar = async () => {
    if (!empresa) return;

    const empresaToUpdate = {
      id: empresa.id,
      timezone,
    };

    try {
      const updatedEmpresa = await service.put(
        "/empresa/changeOnly",
        empresaToUpdate
      );
      setEmpresa(updatedEmpresa);
      setTimezone(updatedEmpresa.timezone);
      service.atualizarEmpresaProfile(updatedEmpresa);

      enqueueSnackbar("Timezone atualizado com sucesso", {
        variant: "success",
      });
    } catch (error) {
      console.error("Erro ao salvar timezone:", error);
      enqueueSnackbar("Falha ao salvar timezone", { variant: "error" });
    }
  };

  return (
    <Paper>
      <Box p={3}>
        <Grid container spacing={2} alignItems="center">
          <Grid
            size={{
              xs: 12,
              md: 10,
            }}
          >
            <TextField
              select
              fullWidth
              variant="outlined"
              name="timezone"
              label="Selecione o timezone (fuso horário) adequado a sua região"
              value={timezone || ""}
              onChange={handleTimezoneChange}
            >
              {TIMEZONES.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 12,
              md: 2,
            }}
          >
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={handleSalvar}
              sx={{ height: "3.5rem" }}
              disabled={!timezone}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
